<app-deny-time-off-request-dialog
    [name]="selectedTimeOffRequest?.employee?.fullName"
    [headerTitle]="'time-off-v3.denyTimeOffRequest' | translate"
    [timeOffDates]="
        {
            key: 'time-off-v3.dateRangeWithTo',
            params: { startDate: selectedTimeOffRequest?.startAtString, endDate: selectedTimeOffRequest?.endAtString },
        } | appTranslate
    "
    [primaryButtonLabel]="'time-off-v3.denyRequest' | translate"
    [openDialog]="isDenyRequestCommentModalOpen"
    (confirmDenyRequest)="onConfirmDenyRequest($event)"
    (closeDenyRequestModal)="onCloseDenyRequestModal()"
>
</app-deny-time-off-request-dialog>
<div class="page-container" [class.loading]="isLoading">
    <ng-container *ngIf="!isLoading">
        <app-header title="{{ 'time-off-v3.timeOffRequests' | translate }}" [menuService]="tabMenuService"></app-header>
        <ui-card class="overflow-hidden" [withMargin]="false" [withSpacing]="false">
            <app-table
                class="h-100"
                [noPadding]="true"
                [useStickyHeader]="false"
                [showOffset]="false"
                [isResponsive]="true"
                [embedded]="true"
                *ngIf="isReady"
                [table]="timeOffRequestsTable"
                (menuItemSelected)="onMenuAction($event)"
            >
                <app-empty-state
                    label="{{ 'time-off-v3.noRequestsFound' | translate }}"
                    src="/assets/illustrations/calendar.png"
                >
                </app-empty-state>
            </app-table>
        </ui-card>
    </ng-container>
</div>
